"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VirtualTourCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative overflow-hidden bg-background py-20 px-4 md:px-8">
      <div className="mx-auto max-w-2xl">
        <div className={`transition-all duration-[var(--duration-medium)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <Card className="border-secondary bg-background-card p-8 md:p-10 shadow-medium">
            <CardContent className="flex flex-col items-center gap-6 text-center p-0">
              <h2 className="font-display text-2xl md:text-3xl font-semibold text-foreground-light leading-tight">
                Experience Our Practice From Home
              </h2>
              <p className="text-foreground-body text-base md:text-lg max-w-lg">
                Take a virtual tour of Alpha Dental and explore our modern, comfortable facility designed with your family's care in mind.
              </p>
              <Link to="https://www.appointnow.com/?P=4826&O=101&PT=0&campaignID=" newTab>
                <Button size="lg" className="bg-primary text-foreground-primary font-semibold shadow-medium hover:bg-primary-hover hover:shadow-strong active:bg-primary-active transition-all duration-[var(--duration-fast)] hover:-translate-y-0.5 active:translate-y-0 px-8 py-6 text-base">
                  Start Virtual Tour
                  <ArrowRight className="size-5" />
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}